import _ from 'lodash'; // Using lodash for a robust camelCase conversion

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNullOrUndefined = (value: any): value is null | undefined => {
  return value === null || value === undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pick = (obj: any, keys: any) => {
  const res = Object.fromEntries(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keys.filter((key: any) => key in obj).map((key: any) => [key, obj[key]])
  );
  return res;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const inclusivePick = (obj: any, keys: any) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.fromEntries(keys.map((key: any) => [key, obj[key]]));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const omit = (obj: any, keys: any) =>
  Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  );

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertObjectToArray = (obj: any) =>
  Object.entries(obj).map(([key, value]) => ({
    name: key,
    value: value,
  }));

  

// Recursively converts all keys of an object (and nested objects/arrays) to camelCase.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keysToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    // If it's an array, map over its elements and recursively convert them
    return obj.map(v => keysToCamelCase(v));
  } else if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    // If it's a plain object (and not null, Date, etc.)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newObj: { [key: string]: any } = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const camelCaseKey = _.camelCase(key); // Use lodash's camelCase
        // Recursively convert the value associated with the key
        newObj[camelCaseKey] = keysToCamelCase(obj[key]);
      }
    }
    return newObj;
  }
  // Return primitives, null, Date objects, etc. as is
  return obj;
}
